import { Divider } from "@blueprintjs/core";

import { useFeatureAlert } from "@/components/helpers/custom-hooks/use-feature-alert";
import { Box } from "@/components/layout/flexbox";
import { Container } from "@/components/pieces/bootstrap";

import { PracticeHeader } from "./PracticeHeader";
import { ForYouScenarios } from "./scenarios/ForYouScenarios";

export function RoleplaysHeader({ pageLoading = false }) {
  const { alertNode } = useFeatureAlert({
    featureType: "ROLEPLAYS",
    title: "Practice Conversations That Matter",
    description:
      "Engage in realistic voice-based dialogues with our AI. Gain instant, in-depth analysis of your performance and receive specific tips to enhance your communication skills.",
    video: { vimeoId: "1007869798", title: "Exec Roleplays" },
  });

  return (
    <>
      <PracticeHeader />
      <Container>
        <Box mt={36} mb={36}>
          <div className="flex justify-center">{alertNode}</div>
          <ForYouScenarios pageLoading={pageLoading} />
          <Box my={[30, 30, 30, 36]}>
            <Divider />
          </Box>
        </Box>
      </Container>
    </>
  );
}
